import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import fileDownload from "js-file-download";
import { setIsSpinnerVisible } from "store/modules/AppConfig/index.store";

import reportApi from "services/reportApi";

import i18next from "i18next";

import { format, subDays } from "date-fns";
import {
  OrdersRequest,
  ReportDataResponse,
  ReportDataRequest,
} from "./types.store";
import { getUTC } from "./report.helper";

export const handleGetDownloadXlsRequest = createAsyncThunk<any, OrdersRequest>(
  "getDowload",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setIsSpinnerVisible(true));

      const utc = getUTC();
      const dateFromFormat = data.dateFrom.concat(`T00:00:01${utc}`);

      const dateToFormat = data.dateTo.concat(`T23:59:59${utc}`);

      const response = await reportApi.get(
        `v1/dealer/${data.dealerId}/orders/download/excel`,
        {
          responseType: "blob",
          params: {
            dateFrom: dateFromFormat,
            dateTo: dateToFormat,
          },
        },
      );

      fileDownload(response.data, `arquivo.xlsx`);

      return response.data;
    } catch (err: any) {
      switch (err?.response?.status) {
        case 400: {
          toast(i18next.t("faileToDownloadGreaterThanSixtyDays").toString(), {
            type: "error",
            autoClose: false,
          });
          break;
        }

        case 404: {
          toast(i18next.t("faileToDownloadNoDate").toString(), {
            type: "error",
            autoClose: false,
          });
          break;
        }
        default: {
          toast(i18next.t("failedToDownloadPleaseTryAgain").toString(), {
            type: "error",
            autoClose: false,
          });
        }
      }

      if (Axios.isAxiosError(err) && err && err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err);
    } finally {
      dispatch(setIsSpinnerVisible(false));
    }
  },
);

export const handleGetReportDataRequest = createAsyncThunk<
  ReportDataResponse,
  ReportDataRequest
>("getReportData", async (data, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));
    const utc = getUTC();
    const dateFrom =
      data.dateFrom?.concat(`T00:00:01${utc}`) ||
      format(subDays(new Date(), 1), "dd/MM/YYYY-HH:mm");
    const dateTo =
      data.dateTo?.concat(`T23:59:59${utc}`) ||
      format(new Date(), "dd/MM/YYYY-HH:mm");

    const response = await reportApi.get(
      `/v1/dealer/${data.dealerId}/dashboard/data?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    );

    return response.data;
  } catch (err) {
    toast(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      err?.response?.data?.description ||
        i18next.t("failedLoadReportDataPleaseAgain").toString(),
      {
        type: "error",
        autoClose: false,
      },
    );

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});
